// Attachment rules for job card files. Shared by the create form, the attachment list and
// the comment composer. Must match the backend limits on card uploads.

import type { Accept } from 'react-dropzone';

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MiB
export const MAX_FILES = 5;

// Allowed types in the react-dropzone Accept shape (mime → extensions); matches backend.
export const CARD_ACCEPT: Accept = {
    'application/pdf': ['.pdf'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
};
